import React, { useEffect } from 'react';
import { Outlet, useLocation } from "react-router-dom";
import moment from 'moment';
import { connect } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import '../../client/js/component/dump/forms/Form.sass';
import roscoLogo from '../../assets/roscolive-logo-horizontal.png';
import { arrowRight } from '../../client/js/component/helpers/iconHelpers';

const EmptyLayout = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'components.emptyLayout' });
	const { loader } = props;
	const { pathname } = useLocation();

	useEffect(() => {
		document.body.classList.add('body-bg');

		if (moment().hour() > 21 || moment().hour() < 6) {
			document.body.classList.add('bg-7')
		}
		else {
			let day = moment().day();
			day = day === 7 ? 6 : day
			day && document.body.classList.add('bg-' + day)
		}

		if (isMobileOnly) {
			document.body.classList.add('mobile');
		}

		const lng = i18n.language;
		if (!localStorage.getItem('language') && ['en', 'fr', 'es'].includes(lng)) {
			i18n.changeLanguage(lng);
			localStorage.setItem('language', lng);
		}

		return () => {
			document.body.classList.remove('body-bg');
		}
	}, []);

	const panelAccess = !['/confirmation', '/reset-password', '/create-password'].find(item => location.pathname.includes(item))

	return (
		<div className="container">
			<div className={`panel panel-default account-form${pathname.startsWith('/wexlink/credentials/') ? ' wex-credentials-form' : ''}`}>
				<div className="panel-heading ui-font-bold">
					<img src={roscoLogo} className="login-logo" />
				</div>
				<Outlet />
				{panelAccess && (
					<div className="panel-body contact-section">
						<h3 className="login-header">
							{t('loginHeader')}
						</h3>
						<div className="login-subheader">
							{t('loginSubheader')}
						</div>
						<a
							href="mailto:sales@roscovision.com"
							className="sales-link"
						>
							{t('linkContactRosco')}
							{arrowRight}
						</a>
					</div>
				)}
			</div>
			{loader}
		</div>
	);
}

export default connect(
	state => ({
		loader: state.loader.loader
	})
)(EmptyLayout);
